import {createMutation} from '@/utils/common.js'

const store = {
  namespaced: true,
  state:() => {
    return {
      show: true, // 是否显示整个模块
      status: 0, // 0: 待上传  1: 上传中  2: 上传成功
      visible: false, // 是否显示窗口
    }
  },
}

store.mutations = createMutation(store.state())

export default store